import 'simplebar/src/simplebar.css'

// highlight
import './utils/highlight'

// editor
import 'react-quill/dist/quill.snow.css'

import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import { AuthProvider } from './contexts/auth/JWTContext'
import { StartupProvider } from './contexts/startup/StartupContext'
import { CategoryProvider } from './contexts/category/CategoryContext'
import { HistoryProvider } from './contexts/startup/history/HistoryContext'
import { TargetProvider } from './contexts/startup/target/TargetContext'
import { PhaseProvider } from './contexts/startup/phase/PhaseContext'
import { UserProvider } from './contexts/user/UserContext'
import { AdminProvider } from './contexts/admin/AdminContext'
import { InvestorProvider } from './contexts/investor/InvestorContext'
import { BlogProvider } from './contexts/blog/BlogContext'
import { TicketProvider } from './contexts/ticket/TicketContext'
import { NotificationProvider } from './contexts/notification/NotificationContext'

import App from './App'
import * as serviceWorker from './serviceWorker'
import reportWebVitals from './reportWebVitals'

import moment from 'moment-jalaali'

import 'moment/locale/fa'
moment.loadPersian({ dialect: 'persian-modern' })

ReactDOM.render(
  <AuthProvider>
    <HelmetProvider>
      <StartupProvider>
        <CategoryProvider>
          <HistoryProvider>
            <TargetProvider>
              <PhaseProvider>
                <UserProvider>
                  <AdminProvider>
                    <InvestorProvider>
                      <BlogProvider>
                        <TicketProvider>
                          <NotificationProvider>
                            <BrowserRouter>
                              <App />
                            </BrowserRouter>
                          </NotificationProvider>
                        </TicketProvider>
                      </BlogProvider>
                    </InvestorProvider>
                  </AdminProvider>
                </UserProvider>
              </PhaseProvider>
            </TargetProvider>
          </HistoryProvider>
        </CategoryProvider>
      </StartupProvider>
    </HelmetProvider>
  </AuthProvider>,
  document.getElementById('root')
)

// If you want to enable client cache, register instead.
serviceWorker.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
